let wordModal = document.querySelector("._word-modal")
let sentenceModal = document.querySelector("._sentence-modal")

let articleText = document.querySelector(".article .text")

if(articleText){
    let paragraphs = articleText.querySelectorAll("p")

    paragraphs.forEach(p => {
        let text = p.innerHTML.replace(/[\wа-яё]+/gim, function(s) {
            // return s === " " ? s : "<span>" +s + "</span>"
            if(s === "nbsp"){
                return ""
            }
            if(s === "&;"){
                return ""
            }
            if(s === " "){
                return ""
            }
            if(s === ""){
                return ""
            }
            if(s === "."){
                return "."
            }
            if(s === ","){
                return ","
            }
            return `<span>${s}</span>`
        });

        p.innerHTML = text.replace(/[&;]/g, '')
    })

    articleText.onmouseup = function(e) {
        let selected_text = "";

        wordModal.style.top = `${e.clientY / 16}em`
        sentenceModal.style.top = `${e.clientY / 16}em`

        if(window.getSelection) {

            selected_text = window.getSelection().toString();

        } else if(document.selection && document.selection.type != "Control") {

            selected_text = document.selection.createRange().text;

        }

        if(!!selected_text) {
            selected_text = selected_text.trim()
            if(selected_text){
                wordModal.classList.remove("_active")
                sentenceModal.classList.add("_active")
            }
        }

    };

    document.addEventListener( 'click', (e) => {
        const withinBoundaries = e.composedPath().includes(articleText);

        if ( ! withinBoundaries ) {
            sentenceModal.classList.remove("_active")
            wordModal.classList.remove("_active")
        }
    })

    document.addEventListener('keydown', function(e) {
        if( e.keyCode == 27 ){
            sentenceModal.classList.remove("_active")
            wordModal.classList.remove("_active")
        }
    });


    let spans = articleText.querySelectorAll("span")
    spans.forEach(span => {
        if(span){
            span.onclick = function () {
                sentenceModal.classList.remove("_active")
                wordModal.classList.add("_active")
            }
        }
    })

    addEventListener("scroll", (event) => {});

    onscroll = (event) => {
        sentenceModal.classList.remove("_active")
        wordModal.classList.remove("_active")
    };
}



